import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import Checkbox from '../../form/Checkbox';
import Select from '../../form/Select';
import SelectEmpresa from '../../form/SelectEmpresa';
import TextArea from '../../form/TextArea';

/* utils */
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';
import { retornaData } from '../../../utils/retornaDataFormatada';

function Form({ token, dados, setDados, empresaId, empresaIds, handleSubmit, btnText, caminhoVoltar, OptionsEmpresa, enumTipo }) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name === 'valor') {
            const valorFormatado = formatarNumeroDecimal(value);
            setDados({
                ...dados,
                [name]: valorFormatado,
            });
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }

    async function handleOnBlur(e) {}
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Indexador</h1>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />
                <Input
                    text="Descrição"
                    type="text"
                    name="descricao"
                    placeholder="Indexador"
                    title="Digite o nome da Indexador"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required={true}
                />
                <InputNumber
                    text="Valor"
                    type="text"
                    name="valor"
                    placeholder="valor"
                    inputWidth="100px"
                    title="valor do indexador, utilizado para calculos de custos"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.valor ? formatarNumero(dados.valor) : ''}
                    required={true}
                />
                <Input
                    text="Unidade"
                    type="text"
                    name="unidade"
                    placeholder="Unidade"
                    inputWidth="100px"
                    title="digite a unidade padrão do indexador, R$, %, m², etc"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.unidade}
                />
                <Select
                    name="tipo"
                    title={'Define o tipo do indexador'}
                    text="Tipo"
                    options={enumTipo}
                    handleOnChange={handleChange}
                    value={dados.tipo}
                    isEnum={true}
                    notOptNull={false}
                />
                <Input
                    text="Início"
                    type="date"
                    name="dataVigenciaInicio"
                    placeholder="Início"
                    title="Data de inicial do indexador"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={(dados.dataVigenciaInicio && retornaData(dados.dataVigenciaInicio)) || null}
                    inputWidth={'150px'}
                />
                <Input
                    text="Fim"
                    type="date"
                    name="dataVigenciaFim"
                    placeholder="Final"
                    title="Data de final do indexador"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={(dados.dataVigenciaFim && retornaData(dados.dataVigenciaFim)) || null}
                    inputWidth={'150px'}
                />
                <Checkbox
                    title="Vigente"
                    text="Vigente"
                    name="vigente"
                    handleOnChange={handleChange}
                    value={dados.vigente}
                    checked={!!dados.vigente}
                />
                <Checkbox
                    title="Ativa quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Checkbox
                    title="Compoe custo de produção"
                    text="Custo"
                    name="compoeCusto"
                    handleOnChange={handleChange}
                    value={dados.compoeCusto}
                    checked={!!dados.compoeCusto}
                />
                <Checkbox
                    title="Custo de energia elétrica no processo de produção"
                    text="Eletricidade"
                    name="eletricidade"
                    handleOnChange={handleChange}
                    value={dados.eletricidade}
                    checked={!!dados.eletricidade}
                />
                <Checkbox
                    title="Compõe o custo do prato para despesas com funcionários nas filiais, ao marcar no modo restaurante que é um custo ou custo filial, o sistema altera o preço do prato para o preço padrão"
                    text="Prato"
                    name="prato"
                    handleOnChange={handleChange}
                    value={dados.prato}
                    checked={!!dados.prato}
                />
                <Checkbox
                    title="Salário Base, o indexador é utilizado como base para o cálculo de salários e composição de custos de produção"
                    text="Salário Base"
                    name="salarioBase"
                    handleOnChange={handleChange}
                    value={dados.salarioBase}
                    checked={!!dados.salarioBase}
                />
            </div>
            <div>
                <TextArea
                    text={`Observações `}
                    type="text"
                    name="observacao"
                    placeholder="Digite aqui as observações"
                    title="Digite as observações"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.observacao || ''}
                    textAlign="left"
                    linhas="4"
                    colunas="120"
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
